var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { resizeImageByCSS } from '../../utils/file';
import Loader from '../Loader';
const AsyncImgLoader = (_a) => {
    var { src, init, originalSize, alt } = _a, props = __rest(_a, ["src", "init", "originalSize", "alt"]);
    const [fetchedImageSrc, setFetchedImage] = useState();
    const loadImage = () => __awaiter(void 0, void 0, void 0, function* () {
        const imgRes = yield fetch(typeof src === 'string' ? src : yield src(), init);
        const dataUrl = URL.createObjectURL(yield imgRes.blob());
        setFetchedImage(dataUrl);
    });
    useEffect(() => {
        loadImage();
    }, []);
    const placeholderSize = originalSize
        ? resizeImageByCSS(props, originalSize)
        : {
            width: props.width,
            height: props.height,
        };
    const content = fetchedImageSrc ? (_jsx("img", Object.assign({ src: fetchedImageSrc, alt: alt }, props, { style: placeholderSize && {
            margin: 0,
        } }), void 0)) : (_jsx(Loader, {}, void 0));
    if (placeholderSize) {
        return (_jsx("div", Object.assign({ style: Object.assign(Object.assign({}, placeholderSize), { backgroundColor: 'var(--ambient-basePlus90)', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }), className: "image" // allow global selector
         }, { children: content }), void 0));
    }
    // Placeholder size cannot be determined
    return _jsx("div", { children: content }, void 0);
};
export default AsyncImgLoader;
